const errorCodes = {
    unitMissingSensors: "E0001",
    unitMissingReport: "E0003"
}

export default errorCodes;